import BreakdownDialog from "./BreakdownDialog";
import { getInvoiceStatusPillStyle } from "./invoiceStatusStyle";

function formatAgingInvoiceAmount(value, currency) {
  const amount = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(amount)) return "-";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return amount.toFixed(2);
  }
}

export const AGING_INVOICE_BREAKDOWN_COLUMNS = [
  { key: "invoice_number", label: "Invoice No." },
  { key: "serial_number", label: "Asset" },
  { key: "lessor", label: "Lessor" },
  { key: "status", label: "Status", type: "pill" },
  { key: "due_date", label: "Due Date", type: "date" },
  { key: "days_overdue", label: "Overdue Days", mono: true },
  { key: "invoice_total", label: "Invoice Total", mono: true },
  { key: "paid", label: "Paid Amount", mono: true },
  { key: "outstanding", label: "Outstanding Amount", mono: true },
];

export function buildAgingInvoiceBreakdownRows(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => ({
    id: index,
    invoice_number: item?.invoice_number || "-",
    serial_number: item?.serial_number || "-" ,
    lessor: item?.lessor || "-",
    status: { label: item?.status || "-", style: getInvoiceStatusPillStyle(item?.status) },
    due_date: item?.due_date,
    days_overdue: item?.days_overdue ?? "-",
    invoice_total: formatAgingInvoiceAmount(item?.invoice_total, item?.currency),
    paid: formatAgingInvoiceAmount(item?.paid, item?.currency),
    outstanding: formatAgingInvoiceAmount(item?.outstanding, item?.currency),
  }));
}

const AgingInvoiceBreakdownModal = ({ open, onClose, bandLabel, rows }) => {
  const title = bandLabel ? `Invoice Breakdown  (${bandLabel})` : "Invoice Breakdown";
  const rowCount = Array.isArray(rows) ? rows.length : 0;
  const countLabel = `${rowCount} ${rowCount === 1 ? "Invoice" : "Invoices"}`;
  return (
    <BreakdownDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={countLabel}
      columns={AGING_INVOICE_BREAKDOWN_COLUMNS}
      rows={rows}
      exportFileName={title}
    />
  );
};

export default AgingInvoiceBreakdownModal;
